/* global axios */
// NOTICE: KAPTION-INTEGRATION
// API client for template attachment uploads
import ApiClient from './ApiClient';

class KaptionTemplateAttachmentsAPI extends ApiClient {
  constructor() {
    super('kaption_template_attachments', { accountScoped: true });
  }

  /**
   * Upload a file to the shortener service
   * @param {File} file - The file to upload
   * @returns {Promise<{url: string, hash: string, expiresAt: string, filename: string, contentType: string}>}
   */
  upload(file) {
    const formData = new FormData();
    formData.append('file', file);

    return axios.post(this.url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}

export default new KaptionTemplateAttachmentsAPI();
